import { TDropItem } from 'src/types';

export const instLvlOptions: TDropItem[] = [
  { value: '', label: 'Choose an Option' },
  { value: '1', label: 'Four or more years' },
  { value: '2', label: 'At least two years but less than four years' },
  { value: '3', label: 'Less than 2 years (below associate)' },
  { value: '-3', label: 'N/A' },
];

export const KEY_OTHER = 'Other';
export const KEY_US_GOV = 'US Government Official';
export const TYPE_OPTIONS: string[] = [
  'Public Post-Secondary Institution',
  'Private Post-Secondary Institution',
  KEY_US_GOV,
  'Foreign Government Official',
  KEY_OTHER,
];
